import React from 'react';
import { Droplets } from 'lucide-react';
import { Card } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { LIQUIDES_ITEMS, LIQUIDE_LEVELS } from './constants';

export const LiquidesSection = ({ workOrder, liquides, onUpdateLiquide }) => {
  const isCompleted = workOrder.status === 'completed';

  const getStatus = (key) => {
    const val = liquides[key];
    if (!val) return null;
    if (typeof val === 'object') return val.status;
    return val;
  };

  const getQuantity = (key) => {
    const val = liquides[key];
    if (val && typeof val === 'object') return val.quantity || '';
    return '';
  };

  const handleStatusClick = (key, levelValue) => {
    if (isCompleted) return;
    const current = getStatus(key);
    if (current === levelValue) {
      onUpdateLiquide(key, null);
    } else if (levelValue === 'appoint') {
      onUpdateLiquide(key, { status: 'appoint', quantity: getQuantity(key) || '' });
    } else {
      onUpdateLiquide(key, levelValue);
    }
  };

  const handleQuantityChange = (key, qty) => {
    if (isCompleted) return;
    onUpdateLiquide(key, { status: 'appoint', quantity: qty });
  };

  return (
    <Card className="p-4 rounded-xl space-y-3" data-testid="wo-liquides-section">
      <h3 className="text-sm font-bold text-slate-900 flex items-center gap-2">
        <Droplets className="w-4 h-4" /> Niveaux de liquides
      </h3>
      <div className="space-y-2">
        {LIQUIDES_ITEMS.map(item => {
          const status = getStatus(item.key);
          const quantity = getQuantity(item.key);
          const isAppoint = status === 'appoint';

          return (
            <div key={item.key} data-testid={`liquide-${item.key}`}>
              <div className="flex items-center justify-between">
                <span className="text-sm text-slate-700 w-48">{item.label}</span>
                <div className="flex gap-1.5">
                  {LIQUIDE_LEVELS.map(level => (
                    <button key={level.value} type="button"
                      onClick={() => handleStatusClick(item.key, level.value)}
                      className={`px-3 py-1.5 rounded-lg text-xs font-medium transition-all ${
                        status === level.value
                          ? `${level.color} text-white shadow-sm`
                          : 'bg-slate-100 text-slate-500 hover:bg-slate-200'
                      } ${isCompleted ? 'cursor-default' : 'cursor-pointer'}`}
                      data-testid={`liquide-${item.key}-${level.value}`}>
                      {level.label}
                    </button>
                  ))}
                </div>
              </div>
              {isAppoint && (
                <div className="ml-48 mt-1.5 flex items-center gap-2" data-testid={`liquide-${item.key}-qty`}>
                  <Input
                    value={quantity}
                    onChange={(e) => handleQuantityChange(item.key, e.target.value)}
                    placeholder="Ex: 0.5L, 1L..."
                    className="h-8 text-sm w-40"
                    disabled={isCompleted}
                    data-testid={`liquide-${item.key}-qty-input`}
                  />
                  <span className="text-xs text-slate-400">quantite utilisee</span>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </Card>
  );
};
